export default "__VITE_ASSET__Dftx1LYQ__"